import Swal from 'sweetalert2';
// const baseUrl = process.env.REACT_APP_API_URL;

const baseUrl = process.env.NODE_ENV === "development" ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL_PROD ;

//console.log(baseUrl)
const calculateRemainingTime = (expirationTime) => {
    const currentTime = new Date().getTime();
    const adjExpirationTime = new Date(expirationTime).getTime();
    const remainingDuration = adjExpirationTime - currentTime;
    return remainingDuration;
 };


const fetchSinToken = ( endpoint, data, method = 'GET' ) => {

    const url = `${ baseUrl }/${ endpoint }`;

    if ( method === 'GET' ) {
        return fetch( url );
    } else {
        return fetch( url, {
            method,
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify( data )
        });
    }
}

const fetchConToken = ( endpoint, data, method = 'GET' ) => {
    
    //TODO Se debe validar si esta corriente antes de pedir un tocken nuevo///////////
    
    try {
        const url = `${ baseUrl }/${ endpoint }`;
        const token = sessionStorage.getItem('token') || '';

        if ( method === 'GET' ) {
            return fetch( url, {
                method,
                headers: {
                    'x-token': token
                }
            });
        } else {
            return fetch( url, {
                method,
                headers: {
                    'Content-type': 'application/json',
                    'x-token': token
                },
                body: JSON.stringify( data )
            });
        }
    } catch (error) {
        console.log(error);
        Swal.fire('Error fetching data', "Error fetching data", 'error');
    }
    
}



export {
    fetchSinToken,
    fetchConToken, 
    calculateRemainingTime,
}